import type { ConfirmationDialogProps } from './ConfirmationDialog.types'

const ConfirmationDialog = (props: ConfirmationDialogProps) => {
  const {
    title,
    message,
    confirmButtonText,
    cancelButtonText = 'Cancel',
    open,
    onConfirm,
    onCancel,
    hideModal,
  } = props

  const handleConfirm = () => {
    onConfirm()
    hideModal()
  }

  const handleCancel = () => {
    onCancel()
    hideModal()
  }

  if (!open) {
    return null
  }

  return (
    <div className="fixed z-10 inset-0 overflow-y-auto">
      <div className="flex items-center justify-center min-h-screen">
        <div className="bg-white rounded-lg shadow-lg p-6">
          <h3 className="text-lg font-medium mb-4">{title}</h3>
          <div className="mb-6">{message}</div>
          <div className="flex justify-end">
            <button
              className="px-4 py-2 mr-2 text-sm font-medium text-gray-700 bg-gray-200 rounded-md hover:bg-gray-300"
              onClick={handleCancel}
            >
              {cancelButtonText}
            </button>
            <button
              className="px-4 py-2 text-sm font-medium text-white bg-blue-500 rounded-md hover:bg-blue-600"
              onClick={handleConfirm}
            >
              {confirmButtonText}
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ConfirmationDialog
